import React from 'react'
import DialogView from '../../../Dialogos/DialogView'
import TablaCalleCamionCalado from './TablaCalleCamionCalado'

function DialogoCalleCamionCaladoUpdate (props) {
  const { cancelCallback } = props
  return (
    <DialogView
      cancelCallback={cancelCallback}
      title='Modificar calle de camión'
      content={
        <TablaCalleCamionCalado />
      }
    />
  )
}

export default DialogoCalleCamionCaladoUpdate
